module.exports = __webpack_public_path__ + "img/hero-bg-shape-4.374dc118.svg";